// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f8a30ceb","757":"119da715","787":"2b0048b2"}[chunkId] + ".chunk.js";
};